// @flow

import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import SignaturePad from 'react-signature-pad-wrapper';
import Button from '../shared/Button';
import Card from './Card';
import Checkbox from './CheckboxInput';

type Props = {
  hasConsent: boolean,
  onToggleConsent: () => void,
  onSubmit: (Object) => void,
  loading: boolean,
  showPadOnly: boolean,
  submitLabel: string,
  confirmationText?: any,
  onConfirmationChange: (hasConfirmed: boolean) => void
} & WithTranslation

class SignatureField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      empty: true
    };
    this.signaturePad = React.createRef();
    this.canvasCopy = React.createRef();
  }

  begin = () => {
    this.setState({
      empty: false,
      active: false
    });
  }

  clear = () => {
    this.signaturePad.current.clear();
    this.setState({
      empty: true,
      active: false
    });
  }

  save = () => {
    const canvas = this.signaturePad.current._canvas;
    // polyfill for Edge browser
    /* eslint-disable */
    if (!HTMLCanvasElement.prototype.toBlob) {
      Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
        value: function (callback, type, quality) {
          const c = this;
          setTimeout(() => {
            const binStr = atob(c.toDataURL(type, quality).split(',')[1]);
            const len = binStr.length;
            const arr = new Uint8Array(len);

            for (let i = 0; i < len; i += 1) {
              arr[i] = binStr.charCodeAt(i);
            }

            callback(new Blob([arr], { type: type || 'image/png' }));
          });
        }
      });
    }
    canvas.toBlob(this.props.onSubmit);
    /* eslint-enable */
  }

  props: Props

  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <div className='authorize-request__signature_container is-center'>
          <Card noBorder noPadding className='signature_card is-center'>
            <div className='signature_card-section'>
              <div
                className={`signature__canvas-container ${this.state.empty && 'show-placeholder'}`}
                role='button'
                tabIndex={0}
                style={{ outline: 'none' }}
                onPointerUp={() => this.setState({ active: true })}
                onPointerDown={this.begin}
              >
                <SignaturePad
                  ref={this.signaturePad}
                  minWidth={0.25}
                  maxWidth={2}
                  redrawOnResize
                />
                <div className='dotted-line-overlay' />
              </div>
            </div>
          </Card>
        </div>
        <div className='signature_card is-center'>
          <a
            role='button'
            tabIndex={0}
            onClick={this.clear}
            className='is-right'
          >
            {t('signaturePad:clear_signature')}
          </a>
        </div>
        <div className='signature_card__confirmation-check is-center'>
          <Checkbox
            checked={this.props.hasConsent}
            onToggle={this.props.onConfirmationChange}
            label={this.props.confirmationText}
            className='checkbox__square'
          />
        </div>
        <div className='authorize-request__signature_container btn-dashboard is-center'>
          <Button
            label={this.props.submitLabel || t('signaturePad:submit')}
            onClick={this.save}
            isDisabled={this.state.empty || !this.props.hasConsent}
            className='is-primary no-transform'
            isLoading={this.props.loading}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation(['signaturePad', 'tooltips'])(SignatureField);



// WEBPACK FOOTER //
// ./src/components/shared/SignaturePad.js